<template>
  <el-dialog class="apple-confirm" :visible.sync="isShowConfirm" :width="width" append-to-body
    :before-close="handleClose">
    <img v-if="isShowCloseIcon" class="close-dialog" src="@/assets/image/close.png" alt="关闭对话框" @click="handleClose">
    <h2 v-if="title && title != ''" class="title">{{ title }}</h2>
    <p v-if="isHaveSlot">
      <slot />
    </p>
    <p v-else class="content">{{ content }}</p>
    <div slot="footer">
      <div v-if="isHaveBtn" class="footer-content">
        <div v-if="!isOneBtn" class="quit" @click="handleClose">{{ quitText }}</div>
        <div v-if="!isOneBtn" class="confirm" @click="handleConfirm">{{ submitText }}</div>
        <div v-if="isOneBtn" class="quit" @click="handleConfirm">{{ oneBtnText }}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'ConfirmDialog',
    props: {
      // 弹窗是否显示
      isShowConfirm: {
        type: Boolean,
        default: false
      },
      // 是否显示关闭按钮
      isShowCloseIcon: {
        type: Boolean,
        default: false
      },
      // 标题 （不传或传空默认没有标题）
      title: {
        type: String,
        default: null
      },
      // 内容
      content: {
        type: String,
        default: ''
      },
      // 弹窗宽度
      width: {
        type: String,
        default: '285px'
      },
      // 左边的取消文字
      quitText: {
        type: String,
        default: '取消'
      },
      // 右边的确认文字
      submitText: {
        type: String,
        default: '确认'
      },
      // 是否只有一个操作按钮
      isOneBtn: {
        type: Boolean,
        default: false
      },
      // 一个按钮的文字
      oneBtnText: {
        type: String,
        default: '知道了'
      },
      // 是否有底部按钮
      isHaveBtn: {
        type: Boolean,
        default: true
      },
      // 自定义内容
      isHaveSlot: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      // 关闭
      handleClose() {
        this.$emit('handleClose')
      },
      // 确认
      handleConfirm() {
        this.$emit('handleConfirm')
      }
    },
    computed: {
    }
  }
</script>

<style lang="scss" scoped>
  .apple-confirm {
    ::v-deep .el-dialog {
      overflow: hidden;
      position: relative;
      border-radius: 8px;
      margin-top: 0vh !important;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  ::v-deep .el-dialog__header {
    display: none;
  }

  .close-dialog {
    position: absolute;
    right: 15px;
    top: 15px;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  .title {
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    margin-bottom: 15px;
  }

  ::v-deep .el-dialog__body {
    // padding: 30px 20px 20px;
    color: $default-font-color;

    .content {
      margin: 0 auto;
      text-align: center;
      // width: 60%;
      line-height: 20px;
      max-height: 275px;
      overflow-y: auto;
    }
  }

  ::v-deep .el-dialog__footer {
    padding: 0;
    border-top: 1px solid #f1f3f8;

    .footer-content {
      height: 42px;
      display: flex;

      .quit,
      .confirm {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        height: 100%;
        cursor: pointer;
      }

      .quit {
        color: $theme-color;
        border-right: 1px solid #f1f3f8;
      }
    }
  }
</style>